<script setup>
import AssetsSelect from '@/views/experimental/map-view/AssetsSelect.vue';
import AssetsSelectModel from '@/views/experimental/map-view/AssetsSelectModel.vue';
import { customCss } from '@/views/experimental/table-view/quasar.js';
import { useStyleTag } from '@vueuse/core';
import { ref, onMounted, onUnmounted } from 'vue';
const { id, css, load, unload } = useStyleTag(customCss, { id: 'nabuto' });

onUnmounted(() => {
  unload();
});
</script>

<template>
  <vx-card>
    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>
    <vs-popup
      title="New Role"
      :active.sync="popupActive12"
      fullscreen
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="roleMetadataRefined.name"
        class="w-full"
      />
      <br />
      <span><b>Pages</b></span>
      <vs-row v-for="item in access.pages" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-if="userInfo.access.pages.includes(item.value)"
            v-model="roleMetadataRefined.pages"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>

      <br />
      <span><b>Reports</b></span>
      <vs-row v-for="item in access.reports" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-model="roleMetadataRefined.reports"
            v-if="userInfo.access.reports.includes(item.value)"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>

      <br />
      <span><b>Actions</b></span>
      <vs-row v-for="item in access.actions" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-model="roleMetadataRefined.actions"
            v-if="userInfo.access.actions.includes(item.value)"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>
      <br />

      Assign Users
      <ejs-multiselect
        id="multiselect3"
        :dataSource="userData"
        v-model="roleMetadataRefined.users"
        :fields="fields3"
        popupHeight="400px"
        mode="CheckBox"
        enableGroupCheckBox="true"
        showDropDownIcon="true"
        allowFiltering="true"
        filterType="contains"
        filterBarPlaceholder="Search"
        showSelectAll="true"
        placeholder="Select Users"
      ></ejs-multiselect>

      <!-- <AssetsSelect
        @selected="
          (v) => {
            // $emit('selected', v);
            roleMetadataRefined.users = v;
          }
        "
        :style="{ width: `500px` }"
        ref="assetSelect"
        :dataSource="userData"
        :f="fields3"
      /> -->
      <br />
      <br />
      <vs-button @click="addRole2">Proceed</vs-button>
    </vs-popup>
    <vs-popup
      title="Edit Role"
      :active.sync="popupActive13"
      fullscreen
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="roleMetadataRefined.name"
        class="w-full"
      />
      <br />
      <span><b>Pages</b></span>
      <vs-row v-for="item in access.pages" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-if="userInfo.access.pages.includes(item.value)"
            v-model="roleMetadataRefined.pages"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>

      <br />
      <span><b>Reports</b></span>
      <vs-row v-for="item in access.reports" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-model="roleMetadataRefined.reports"
            v-if="userInfo.access.reports.includes(item.value)"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>

      <br />
      <span><b>Actions</b></span>
      <vs-row v-for="item in access.actions" :key="item.value">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2"
          >{{ item.label }}
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
          <vs-switch
            color="success"
            v-model="roleMetadataRefined.actions"
            v-if="userInfo.access.actions.includes(item.value)"
            :vs-value="item.value"
          />
          <span v-else>Disabled</span>
        </vs-col>
      </vs-row>
      <br />
      Assign Users
      <ejs-multiselect
        id="multiselect3"
        :dataSource="userData"
        v-model="roleMetadataRefined.users"
        :fields="fields3"
        popupHeight="400px"
        mode="CheckBox"
        enableGroupCheckBox="true"
        showDropDownIcon="true"
        allowFiltering="true"
        filterType="contains"
        filterBarPlaceholder="Search"
        showSelectAll="true"
        placeholder="Select Users"
      ></ejs-multiselect>

      <!-- <AssetsSelect
        @selected="
          (v) => {
            // $emit('selected', v);
            roleMetadataRefined.users = v;
          }
        "
        :style="{ width: `500px` }"
        ref="assetSelect"
        :dataSource="userData"
        :f="fields3"
      /> -->
      <br />
      <br />

      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
          <vs-button @click="updateRole">Update</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
          <vs-button color="danger" @click="deleteRole">Delete Role</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-popup
      fullscreen
      :title="'Add User'"
      :active.sync="popupActive9"
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="selectedUser.name"
        class="w-full"
      />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="username"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Username"
            v-model="selectedUser.username"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="password"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Password"
            v-model="selectedUser.password"
            class="w-full"
          />
        </div>
      </div>

      <br />

      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Email"
            v-model="selectedUser.email"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="help_call"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Support Phone"
            v-model="userMetadataRefined.help_call"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="help_whatsapp"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Support Whatsapp"
            v-model="userMetadataRefined.help_whatsapp"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Company"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Company"
            v-model="userMetadataRefined.company"
            class="w-full"
          />
        </div>
      </div>

      <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <label>Select Created User</label>
          <v-select
            :options="userData"
            placeholder="Select Created User"
            v-model="userMetadataRefined.createdBy"
            :clearable="false"
            value="username"
            label="username"
          >
            <template slot="option" slot-scope="option">
              {{ option.username }} / {{ option.name }}
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label>Select Role</label>
          <v-select
            :options="roleData"
            placeholder="Select Role"
            v-model="userMetadataRefined.role"
            :clearable="false"
            value="id"
            label="name"
          >
            <template slot="option" slot-scope="option">
              #{{ option.id }} / {{ option.name }}
            </template>
          </v-select>
        </div>
        <!--
    <div class="vx-col md:w-1/4 w-half">
      <label>Role</label>           <v-select placeholder="Role"  :clearable="false" :options="['Client']" class="mb-4 md:mb-0"  v-model="selectedUser.role"/>

</div>
-->
      </div>

      <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
      <br /><br />

      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <label>User Status</label>
          <v-select
            placeholder="Status"
            :clearable="false"
            :options="[
              'ACTIVE',
              'INACTIVE - PAYMENT RELATED',
              'INACTIVE - DISMANTLED',
              'INACTIVE - SUSPICIOUS USAGE',
            ]"
            class="mb-4 md:mb-0"
            v-model="selectedUser.status"
          />
        </div>
      </div>

      <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          Assign Units
          <!-- <ejs-multiselect
            id="multiselect"
            :fields="fields1"
            v-model="selectedUser.units"
            :dataSource="unitData"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Units"
          >
          </ejs-multiselect> -->

          <AssetsSelectModel
            v-model="selectedUser.units"
            :style="{ width: `500px` }"
            :dataSource="unitData"
            :f="fields1"
          />

          <!-- <AssetsSelect
            @selected="
              (v) => {
                // $emit('selected', v);
                selectedUser.units = v;
              }
            "
            :style="{ width: `500px` }"
            ref="assetSelect"
            :dataSource="unitData"
            :f="fields1"
          /> -->
        </div>
        <div class="vx-col md:w-1/2 w-half" :key="'a' + refreshKey">
          Assign to Groups
          <ejs-multiselect
            id="multiselect2"
            :dataSource="groupData"
            :fields="fields2"
            v-model="selectedUser.groups"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Groups"
          ></ejs-multiselect>

          <!-- <AssetsSelect
            @selected="
              (v) => {
                // $emit('selected', v);
                selectedUser.groups = v;
              }
            "
            :style="{ width: `500px` }"
            :dataSource="groupData"
            :f="fields2"
          /> -->
          <br />
        </div>
        <!--
<div class="vx-col md:w-1/2 w-half">
  Assign to Groups      <ejs-multiselect id='multiselect2' :dataSource='groupData' :fields='fields2'  v-model="selectedUser.groups" popupHeight="400px" mode="CheckBox"  enableGroupCheckBox="true" showDropDownIcon="true"  allowFiltering="true" filterType="contains" filterBarPlaceholder="Search" showSelectAll="true" placeholder="Select Groups"></ejs-multiselect><br>

</div>
-->
      </div>
      <br />
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-feather"
        size="small"
        @click="addUser2"
        >Add User</vs-button
      >
      <br />
    </vs-popup>
    <vs-popup
      fullscreen
      :title="'Update User - ' + selectedUser.name"
      :active.sync="popupActive5"
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="selectedUser.name"
        class="w-full"
      />
      <br />

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="username"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Username"
            v-model="selectedUser.username"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="password"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Password"
            v-model="selectedUser.password"
            class="w-full"
          />
        </div>
      </div>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Email"
            v-model="selectedUser.email"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="help_call"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Support Phone"
            v-model="userMetadataRefined.help_call"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="help_whatsapp"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Support Whatsapp"
            v-model="userMetadataRefined.help_whatsapp"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Company"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Company"
            v-model="userMetadataRefined.company"
            class="w-full"
          />
        </div>
      </div>

      <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          Select Role
          <ejs-multiselect
            id="multiselectxx"
            :fields="fields6"
            v-model="userMetadataRefined.role"
            :dataSource="roleData"
            popupHeight="400px"
            maximumSelectionLength="1"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Select Role"
          ></ejs-multiselect>

          <!-- <AssetsSelect
            @selected="
              (v) => {
                // $emit('selected', v);
                userMetadataRefined.role = v;
              }
            "
            :style="{ width: `500px` }"
            ref="assetSelect"
            :dataSource="roleData"
            :f="fields6"
          /> -->
        </div>
        <!--
        </div>
            <div class="vx-col md:w-1/4 w-half">
      <label>Select Created User</label>      <v-select :options="userData" placeholder="Select Created User" v-model="userMetadataRefined.createdByX" :clearable="false" value="username" label="username"  >
    <template slot="option" slot-scope="option">
         {{option.username}} / {{option.name}}
    </template>
  </v-select>

    </div>
-->
        <!--
    <div class="vx-col md:w-1/4 w-half">
      <label>Role</label>           <v-select :clearable="false" placeholder="Role" :options="['Administrator','Client']" class="mb-4 md:mb-0"  v-model="selectedUser.role"/>

</div>
-->
      </div>

      <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="Phone"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Phone"
        v-model="userMetadataRefined.phone"
        class="w-full"/> -->
      <br /><br />

      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <label>User Status</label>
          <v-select
            :clearable="false"
            placeholder="Status"
            :options="[
              'ACTIVE',
              'INACTIVE - PAYMENT RELATED',
              'INACTIVE - DISMANTLED',
              'INACTIVE - SUSPICIOUS USAGE',
            ]"
            class="mb-4 md:mb-0"
            v-model="selectedUser.status"
          />
        </div>
      </div>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half" :key="'b' + refreshKey">
          Assign Units
          <!-- <ejs-multiselect
            id="multiselect"
            :fields="fields1"
            v-model="selectedUser.units"
            :dataSource="unitData"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Units"
          ></ejs-multiselect> -->

          <!-- {{ selectedUser.units }} -->
          <AssetsSelectModel
            v-model="selectedUser.units"
            :style="{ width: `500px` }"
            :dataSource="unitData"
            :f="fields1"
          />
        </div>
        <div class="vx-col md:w-1/2 w-half" :key="'c' + refreshKey">
          Assign to Groups
          <ejs-multiselect
            id="multiselect2"
            :dataSource="groupData"
            :fields="fields2"
            v-model="selectedUser.groups"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="true"
            placeholder="Select Groups"
          ></ejs-multiselect>

          <!-- <AssetsSelect
            @selected="
              (v) => {
                // $emit('selected', v);
                selectedUser.groups = v;
              }
            "
            :style="{ width: `500px` }"
            ref="assetSelect"
            :dataSource="groupData"
            :f="fields2"
          /> -->
          <br />
        </div>
        <!--
<div class="vx-col md:w-1/2 w-half" :key="refreshKey">
  Assign to Groups      <ejs-multiselect id='multiselect2' :dataSource='groupData' :fields='fields2'  v-model="selectedUser.groups" popupHeight="400px" mode="CheckBox"  enableGroupCheckBox="true" showDropDownIcon="true"  allowFiltering="true" filterType="contains" filterBarPlaceholder="Search" showSelectAll="true" placeholder="Select Groups"></ejs-multiselect><br>

</div>
-->
      </div>
      <br /><br />

      <span>Telegram Accounts</span>
      <vs-table stripe :data="userMetadataRefined.telegram" style="z-index: 1">
        <template slot="thead">
          <vs-th width="5%">No.</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Chat Id</vs-th>
          <vs-th>Actions</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>
                <b>{{ indextr + 1 }}.</b></span
              >
            </vs-td>
            <vs-td>
              <span>
                <b>{{ tr.name }}.</b></span
              >
            </vs-td>
            <vs-td>
              <span>
                <b>{{ tr.chatId }}.</b></span
              >
            </vs-td>
            <vs-td>
              <vs-button size="small" @click="removeTelegram(indextr)"
                >Remove</vs-button
              >
              &nbsp;
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="updateUser"
            >Update</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="deleteUserSessions"
            >Force Logout</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half" :key="'d' + refreshKey">
          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="deleteUser"
            >Delete User</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      :title="'New Group'"
      :active.sync="popupActive4"
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="selectedGroup.name"
        class="w-full"
      />
      <br />
      <div :key="'e' + refreshKey">
        Assign Units
        <!-- <ejs-multiselect
          id="multiselect"
          :fields="fields1"
          v-model="selectedGroup.units"
          :dataSource="unitData"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Units"
        ></ejs-multiselect> -->
        <!-- {{ selectedGroup.units }} -->
        <AssetsSelectModel
          v-model="selectedGroup.units"
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="unitData"
          :f="fields1"
        />
        <br />
        Assign Users
        <ejs-multiselect
          id="multiselect3"
          :dataSource="userData"
          v-model="selectedGroup.users"
          :fields="fields3"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Users"
        ></ejs-multiselect>

        <!-- <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selectedGroup.users = v;
            }
          "
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="userData"
          :f="fields3"
        /> -->
        <br />
        <br />
        Assign POI
        <ejs-multiselect
          id="multiselect4"
          :dataSource="poiData"
          v-model="selectedGroup.poi"
          :fields="fields4"
          popupHeight="300px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select POI"
        ></ejs-multiselect>

        <!-- <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selectedGroup.poi = v;
            }
          "
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="poiData"
          :f="fields4"
        /> -->
        <br />
      </div>
      <br />

      <br /><br />
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-feather"
        size="small"
        @click="addGroup2"
        >Add New Group</vs-button
      >
    </vs-popup>
    <vs-popup
      fullscreen
      :title="'Update Group - ' + selectedGroup.name"
      :active.sync="popupActive3"
      style="z-index: 9999999"
    >
      <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="name"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Name"
        v-model="selectedGroup.name"
        class="w-full"
      />
      <div :key="'f' + refreshKey">
        <br />
        Assign Units
        <!-- <ejs-multiselect
          id="multiselect"
          :fields="fields1"
          v-model="selectedGroup.units"
          :dataSource="unitData"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Units"
        ></ejs-multiselect> -->
        <!-- {{ selectedGroup.units }} -->
        <AssetsSelectModel
          v-model="selectedGroup.units"
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="unitData"
          :f="fields1"
        />

        <br />
        Assign Users
        <ejs-multiselect
          id="multiselect3"
          :dataSource="userData"
          v-model="selectedGroup.users"
          :fields="fields3"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Users"
        ></ejs-multiselect>

        <!-- <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selectedGroup.users = v;
            }
          "
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="userData"
          :f="fields3"
        /> -->
        <br />
        <br />
        Assign POI
        <ejs-multiselect
          id="multiselect4"
          :dataSource="poiData"
          v-model="selectedGroup.poi"
          :fields="fields4"
          popupHeight="300px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select POI"
        ></ejs-multiselect>

        <!-- <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selectedGroup.poi = v;
            }
          "
          :style="{ width: `500px` }"
          ref="assetSelect"
          :dataSource="poiData"
          :f="fields4"
        /> -->
        <br />
        <br />
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-feather"
          size="small"
          @click="updateGroup"
          >Update</vs-button
        >

        <br />
        <vs-button
          v-if="selectedGroup.id != 1"
          color="danger"
          type="filled"
          icon-pack="feather"
          icon="icon-feather"
          size="small"
          @click="deleteGroup"
          >Delete</vs-button
        >
        <br />
      </div>
    </vs-popup>
    <vs-tabs>
      <vs-tab label="Users" icon="person">
        <vs-button size="small" @click="addUser">Add New User</vs-button><br />
        <ejs-grid
          :key="'g' + refreshKey"
          :dataSource="userData"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick3"
          :allowTextWrap="true"
          height="40vh"
          gridLines="Both"
          :filterSettings="filterOptions"
          :allowPaging="true"
          :searchSettings="searchOptions2"
          :toolbar="toolbarOptions"
          ref="userUsersGrid"
          id="userUsersGrid"
          :pageSettings="pageSettings"
          :showColumnChooser="true"
          :allowSorting="true"
          :allowMultiSorting="true"
          :allowFiltering="true"
        >
          <e-columns>
            <e-column
              field="username"
              headerText="Username"
              textAlign="Left"
            ></e-column>
            <e-column
              field="password"
              headerText="Password"
              textAlign="Left"
            ></e-column>
            <e-column
              field="name"
              headerText="Full Name"
              textAlign="Left"
            ></e-column>
            <e-column
              field="company"
              headerText="Company"
              textAlign="Left"
            ></e-column>
            <e-column
              field="phone"
              headerText="Phone"
              textAlign="Left"
            ></e-column>
            <e-column
              field="email"
              headerText="E-mail"
              textAlign="Left"
            ></e-column>
            <e-column
              field="roleName"
              headerText="Role"
              textAlign="Left"
            ></e-column>
            <e-column
              field="createdBy"
              headerText="Created By"
              textAlign="Left"
            ></e-column>
            <e-column
              headerText="Manage"
              textAlign="Left"
              :template="cTemplate"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </vs-tab>
      <vs-tab label="Groups" icon="group">
        <vs-button size="small" @click="addGroup">Add New Group</vs-button
        ><br />
        <ejs-grid
          :key="'h' + refreshKey"
          :dataSource="groupData"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick2"
          :allowTextWrap="true"
          height="40vh"
          gridLines="Both"
          :filterSettings="filterOptions"
          :allowPaging="true"
          :searchSettings="searchOptions3"
          :toolbar="toolbarOptions"
          ref="adminGroupsGrid"
          id="adminGroupsGrid"
          :pageSettings="pageSettings"
          :showColumnChooser="true"
          :allowSorting="true"
          :allowMultiSorting="true"
          :allowFiltering="true"
        >
          <e-columns>
            <e-column
              field="name"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column
              field="unitsCount"
              headerText="Units"
              textAlign="Left"
            ></e-column>
            <!--    <e-column field='usersCount' headerText='Users'  textAlign='Left'></e-column>-->
            <e-column
              field="poiCount"
              headerText="POI"
              textAlign="Left"
            ></e-column>
            <e-column
              headerText="Manage"
              textAlign="Left"
              :template="cTemplate3"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </vs-tab>
      <vs-tab label="Roles" icon="person">
        <vs-button size="small" @click="addRole">Add New Role</vs-button><br />
        <ejs-grid
          :key="'i' + refreshKey"
          :dataSource="roleData"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick6"
          :allowTextWrap="true"
          height="40vh"
          gridLines="Both"
          :filterSettings="filterOptions"
          :allowPaging="true"
          :searchSettings="searchOptions6"
          :toolbar="toolbarOptions"
          ref="adminRolesGrid"
          id="adminRolesGrid"
          :pageSettings="pageSettings"
          :showColumnChooser="true"
          :allowSorting="true"
          :allowMultiSorting="true"
          :allowFiltering="true"
        >
          <e-columns>
            <e-column
              field="name"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column
              headerText="Manage"
              textAlign="Left"
              :template="cTemplate2"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './actionButtonTemplate.vue';
import columntempVue2 from './actionButtonTemplate2.vue';
import columntempVue3 from './actionButtonTemplate3.vue';
import vSelect from 'vue-select';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    columntempVue2,
    columntempVue3,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      access: {
        pages: [
          { label: 'Map View', value: 'mapview' },
          { label: 'Table View', value: 'tableview' },
          { label: 'Hybrid View', value: 'hybridview' },
          { label: 'Multi View', value: 'multiview' },
          { label: 'Playback', value: 'playback' },
          { label: 'FMS (Maintenance)', value: 'fms' },
          { label: 'Vessel (VMS)', value: 'vms' },
          { label: 'Transport Mgmt (TMS)', value: 'tms' },
          { label: 'Reports', value: 'reports' },
        ],
        reports: [
          { label: 'History', value: 'History' },
          { label: 'Fuel', value: 'Fuel' },
          { label: 'Mileage', value: 'Mileage' },
          { label: 'Notification', value: 'Notification' },
          { label: 'Alarm', value: 'Alarm' },
          { label: 'Fuel Receipt', value: 'Fuel Receipt' },
          { label: 'Toll Receipt', value: 'Toll Receipt' },
          { label: 'Input', value: 'Input' },
          { label: 'Input 2', value: 'Input 2' },
          { label: 'Input 3', value: 'Input 3' },
          { label: 'Summary', value: 'Summary' },
          { label: 'Temperature', value: 'Temperature' },
          { label: 'Maintenance Log', value: 'Maintenance Log' },
          { label: 'History - Watch', value: 'History - Watch' },
          { label: 'POI - Watch', value: 'POI - Watch' },
          { label: 'POI', value: 'POI' },
         { label: 'Fatigue Driving', value: 'Fatigue Driving' },
        ],
        actions: [
          { label: 'On Immo', value: 'immo-on' },
          { label: 'Off Immo', value: 'immo-off' },
          { label: 'POI - Add', value: 'poi-add' },
          { label: 'POI - Delete', value: 'poi-delete' },
          { label: 'POI - Manage Alarms', value: 'poi-alarms' },
          { label: 'Events - Add New', value: 'events-add' },
          { label: 'Events - Update', value: 'events-update' },
          { label: 'Events - Delete Event', value: 'events-delete' },
          { label: 'Events - Admin Access', value: 'events-staff' },
          { label: 'Vessel - Agency Access', value: 'vessel-agency' },
          { label: 'Automated Reports - Add New', value: 'reports-add' },
          { label: 'Automated Reports - Update', value: 'reports-update' },
          { label: 'Automated Reports - Delete', value: 'reports-delete' },
          { label: 'Automated Reports - Admin Access', value: 'reports-staff' },
          { label: 'Smartwatch - Monitor', value: 'smartwatch-monitor' },
          { label: 'Smartwatch - Command Access', value: 'smartwatch-command' },
          { label: 'Data Push - Add New', value: 'datapush-add' },
          { label: 'Data Push - Update', value: 'datapush-update' },
          { label: 'Data Push - Delete Event', value: 'datapush-delete' },
          { label: 'Data Push - Admin Access', value: 'datapush-staff' },
        ],
      },
      userData: [],
      roleData: [],
      groupData: [],
      poiData: [],
      popupActive3: false,
      popupActive12: false,
      popupActive13: false,
      popupActive4: false,
      unitData: JSON.parse(localStorage.getItem('unitSelection')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      refreshKey: 0,
      isLoading: false,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      fields1: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      fields11: { groupBy: 'assetGroup', text: 'assetName', value: 'id' },
      fields2: { text: 'name', value: 'id' },
      fields3: { text: 'username', value: 'id' },
      fields4: { text: 'name', value: 'poiId' },
      fields5: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      fields6: { text: 'name', value: 'id' },
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions2: {
        fields: [
          'name',
          'username',
          'password',
          'company',
          'phone',
          'email',
          'createdBy',
          'roleName',
        ],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions3: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions4: {
        fields: ['type', 'reference'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions6: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      selectedUnit: {},
      selectedGroup: {},
      unitMetadataRefined: {},
      popupActive5: false,
      popupActive9: false,
      selectedUser: {},
      userMetadataRefined: {},
      roleMetadataRefined: {
        name: '',
        createdBy: '',
        createdById: -1,
        pages: [
          'mapview',
          'tableview',
          'hybridview',
          'multiview',
          'playback',
          'tms',
          'fms',
          'reports',
        ],
        reports: [
          'Alarm',
          'Fuel',
          'History',
          'Input',
          'Mileage',
          'Notification',
          'Summary',
          'Temperature',
        ],
        actions: ['immo-on', 'immo-off'],
      },
      selectedRole: {},
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate2() {
        return { template: columntempVue2 };
      },
      cTemplate3() {
        return { template: columntempVue3 };
      },
    };
  },
  watch: {},
  methods: {
    toolbarClick2(args) {
      if (args.item.id === 'adminGroupsGrid_excelexport') {
        //  this.$refs.adminGroupsGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Groups - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminGroupsGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminGroupsGrid_pdfexport') {
        //         this.$refs.adminGroupsGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Groups - Listing.pdf',
        };
        this.$refs.adminGroupsGrid.pdfExport(exportProperties);
      }
    },
    toolbarClick6(args) {
      if (args.item.id === 'adminRolesGrid_excelexport') {
        //  this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Roles - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminRolesGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminRolesGrid_pdfexport') {
        //               this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Roles - Listing.pdf',
        };
        this.$refs.adminRolesGrid.pdfExport(exportProperties);
      }
    },
    addRole() {
      const self = this;
      self.roleMetadataRefined = {
        name: '',
        users: [],
        createdBy: self.userInfo.username,
        createdById: self.userInfo.uid,
        pages: [
          'mapview',
          'tableview',
          'hybridview',
          'multiview',
          'playback',
          'tms',
          'fms',
          'reports',
        ],
        reports: [
          'Alarm',
          'Fuel',
          'History',
          'Input',
          'Mileage',
          'Notification',
          'Summary',
          'Temperature',
        ],
        actions: ['immo-on', 'immo-off'],
      };
      self.popupActive12 = true;
    },
    addRole2() {
      const self = this;
      if (self.roleMetadataRefined.name == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Key in valid role name.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .post('roles', {
          meta: self.roleMetadataRefined,
        })
        .then(function (response) {
          self.popupActive12 = false;
          self.getData();
          self.roleMetadataRefined = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new role details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    editRole(data) {
      const self = this;
      self.selectedRole = data;
      self.roleMetadataRefined = JSON.parse(data.meta);
      self.roleMetadataRefined.users = data.users;
      self.popupActive13 = true;
    },
    updateRole() {
      const self = this;
      if (self.roleMetadataRefined.name == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Key in valid role name.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .patch('roles', {
          id: self.selectedRole.id,
          meta: self.roleMetadataRefined,
        })
        .then(function (response) {
          self.popupActive13 = false;
          self.getData();
          self.roleMetadataRefined = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteRole() {
      const self = this;
      self.$http
        .delete(`roles/${self.selectedRole.id}`, {})
        .then(function (response) {
          self.popupActive13 = false;
          self.getData();
          self.roleMetadataRefined = {};
          self.selectedRole = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete role.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete role.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    getData() {
      const self = this;
      self.$http
        .get(`admin/users/main/${self.userInfo.uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.userData = response.data.userData;
            self.groupData = response.data.groupData;
            self.roleData = response.data.roleData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    getData2() {
      const self = this;
      self.$http
        .get(`settings/poi/${self.userInfo.uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.poiData = response.data.poiData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    toolbarClick3(args) {
      if (args.item.id === 'userUsersGrid_excelexport') {
        //  this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          fileName: 'Users - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.userUsersGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'userUsersGrid_pdfexport') {
        //               this.$refs.adminUsersGrid.getColumns()[4].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Users - Listing.pdf',
        };
        this.$refs.userUsersGrid.pdfExport(exportProperties);
      }
    },
    addGroup() {
      const self = this;
      self.selectedGroup = {
        name: '',
        units: [],
        users: [],
        poi: [],
        createdBy: self.userInfo.username,
        createdById: self.userInfo.uid,
      };
      self.refreshKey += 1;
      self.popupActive4 = true;
    },
    addGroup2() {
      const self = this;
      self.$http
        .post('admin/groups', {
          createdById: self.userInfo.uid,
          main: self.selectedGroup,
        })
        .then(function (response) {
          self.popupActive4 = false;
          self.getData();
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new group details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    updateGroup() {
      const self = this;
      self.$http
        .patch('admin/groups', {
          createdById: self.userInfo.uid,
          main: self.selectedGroup,
          id: self.selectedGroup.id,
        })
        .then(function (response) {
          self.popupActive3 = false;
          self.getData();
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated group details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteGroup() {
      const self = this;
      self.$http
        .delete(`admin/groups/${self.selectedGroup.id}`, {})
        .then(function (response) {
          self.getData();
          self.popupActive3 = false;
          self.selectedGroup = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted group records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete group.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete group.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    addUser() {
      const self = this;
      self.selectedUser = {
        status: 'ACTIVE',
        role: 'Client',
      };
      self.userMetadataRefined = {
        immo: false,
        streetview: false,
        fms: false,
        status: 'ACTIVE',
        help_call: self.userInfo.help_call,
        help_whatsapp: self.userInfo.help_whatsapp,
        createdBy: {
          username: self.userInfo.username,
          name: self.userInfo.displayName,
          id: self.userInfo.uid,
        },
      };
      self.popupActive9 = true;
    },
    addUser2() {
      const self = this;
      if (
        !self.userMetadataRefined.role ||
        !self.userMetadataRefined.role.id ||
        !self.userMetadataRefined.role.name
      ) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select User Role',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      const roleId = self.userMetadataRefined.role.id || null;
      const roleName = self.userMetadataRefined.role.name || null;
      self.userMetadataRefined.roleId = roleId;
      self.userMetadataRefined.roleName = roleName;
      self.$http
        .post('admin/users', {
          main: self.selectedUser,
          meta: self.userMetadataRefined,
        })
        .then(function (response) {
          self.popupActive9 = false;
          self.getData();
          self.userMetadataRefined = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Add new user details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not add user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not add user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    editUser(selectedUser) {
      const self = this;
      self.selectedUser = selectedUser;
      if (selectedUser.groups == '' || selectedUser.groups == null) {
        self.selectedUser.groups = [];
      }
      if (
        selectedUser.groups != null &&
        selectedUser.groups != '' &&
        !selectedUser.groups.includes(',')
      ) {
        self.selectedUser.groups = [Number(selectedUser.groups)];
      }
      if (
        selectedUser.groups != null &&
        selectedUser.groups != '' &&
        selectedUser.groups.includes(',')
      ) {
        self.selectedUser.groups = selectedUser.groups.split(',').map(Number);
      }
      if (selectedUser.units == '' || selectedUser.units == null) {
        self.selectedUser.units = [];
      }
      if (
        selectedUser.units != null &&
        selectedUser.units != '' &&
        !selectedUser.units.includes(',')
      ) {
        self.selectedUser.units = [Number(selectedUser.units)];
      }
      if (
        selectedUser.units != null &&
        selectedUser.units != '' &&
        selectedUser.units.includes(',')
      ) {
        self.selectedUser.units = selectedUser.units.split(',').map(Number);
      }
      self.userMetadataRefined = JSON.parse(self.selectedUser.meta);
      self.userMetadataRefined.createdBy = {
        username: self.userMetadataRefined.createdBy,
        id: self.userMetadataRefined.createdById,
      };
      self.userMetadataRefined.telegram = JSON.parse(
        self.userMetadataRefined.telegram,
      );
      // self.refreshKey+=1;
      self.userMetadataRefined.role = [Number(self.userMetadataRefined.roleId)];
      self.popupActive5 = true;
    },
    editGroup(selectedGroup) {
      const self = this;

      self.selectedGroup = selectedGroup;

      self.$http
        .patch('admin/groups/edit', {
          createdById: self.userInfo.uid,
          id: self.selectedGroup.id,
        })
        .then(function (response) {
          self.selectedGroup.users = response.data.users;
          self.selectedGroup.oldUsers = response.data.users;

          if (selectedGroup.poi == '' || selectedGroup.poi == null) {
            self.selectedGroup.poi = [];
          }
          if (
            selectedGroup.poi != null &&
            selectedGroup.poi != '' &&
            !selectedGroup.poi.includes(',')
          ) {
            self.selectedGroup.poi = [Number(selectedGroup.poi)];
          }
          if (
            selectedGroup.poi != null &&
            selectedGroup.poi != '' &&
            selectedGroup.poi.includes(',')
          ) {
            self.selectedGroup.poi = selectedGroup.poi.split(',').map(Number);
          }

          if (selectedGroup.units == '' || selectedGroup.units == null) {
            self.selectedGroup.units = [];
          }

          if (
            selectedGroup.units != null &&
            selectedGroup.units != '' &&
            !selectedGroup.units.includes(',')
          ) {
            self.selectedGroup.units = [Number(selectedGroup.units)];
          }

          if (
            selectedGroup.units != null &&
            selectedGroup.units != '' &&
            selectedGroup.units.includes(',')
          ) {
            self.selectedGroup.units = selectedGroup.units
              .split(',')
              .map(Number);
          }

          self.popupActive3 = true;
          self.refreshKey += 1;
        })
        .catch(function (error) {});
    },
    updateUser() {
      const self = this;
      if (!self.userMetadataRefined.createdBy) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select created by user.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      if (!self.userMetadataRefined.role || !self.userMetadataRefined.role[0]) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select User Role',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      const ind = self.roleData.findIndex(
        (x) => x.id == self.userMetadataRefined.role[0],
      );
      self.userMetadataRefined.roleId = self.roleData[ind].id;
      self.userMetadataRefined.roleName = self.roleData[ind].name;
      self.$http
        .patch('admin/users', {
          main: self.selectedUser,
          meta: self.userMetadataRefined,
          id: self.selectedUser.id,
        })
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated user details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: `Could not update user.${response.data.error}`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteUser() {
      const self = this;
      self.$http
        .delete(`admin/users/${self.selectedUser.id}`, {})
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted user records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete user.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    deleteUserSessions() {
      const self = this;
      self.$http
        .patch(`admin/users-clear-sessions/${self.selectedUser.id}`, {})
        .then(function (response) {
          self.popupActive5 = false;
          self.getData();
          self.userMetadataRefined = {};
          self.selectedUser = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted user sessions records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user sessions.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete user sessions.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete user sessions.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
  },
  mounted() {
    this.getData();
    this.getData2();
  },
};
</script>
<style>
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
